'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { BecomeAnOperatorDialog } from '@/modules/shared/components/become-an-operator';
import OperatorIcon from '@/modules/shared/components/svgs/operator-icon.svg';
import { useMyBuilderProfile } from '@/modules/shared/hooks/use-my-builder-profile';
interface UpgradeToOperatorCardProps {
  /**
   * Dialog open state is owned by the parent so a successful upgrade (which
   * refetches the drives list and would otherwise swap this card out) can't
   * unmount the dialog's success screen while it's still open.
   */
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Shown when a user arriving with operator intent has completed onboarding but
 * is still only a builder. Offers the upgrade-to-operator flow inline by opening
 * the shared `BecomeAnOperatorDialog`.
 */
function UpgradeToOperatorCard(t0) {
  const $ = _c(11);
  const {
    open,
    onOpenChange
  } = t0;
  const {
    profileQuery
  } = useMyBuilderProfile();
  const profileName = profileQuery.data?.name ?? undefined;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-primary/10 text-primary flex size-12 items-center justify-center rounded-full"><OperatorIcon className="size-6" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-2"><h2 className="text-2xl font-semibold tracking-tight">Become an Operator</h2><p className="text-muted-foreground max-w-md text-sm">You're set up as a builder. Upgrade to an operator to start offering your own services.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onOpenChange) {
    t3 = <Button onClick={() => {
      onOpenChange(true);
    }}>Become an Operator</Button>;
    $[2] = onOpenChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onOpenChange || $[5] !== open || $[6] !== profileName) {
    t4 = <BecomeAnOperatorDialog open={open} onOpenChange={onOpenChange} profileName={profileName} />;
    $[4] = onOpenChange;
    $[5] = open;
    $[6] = profileName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Card><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t1}{t2}{t3}{t4}</CardContent></Card>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export { UpgradeToOperatorCard };